import { DateTime } from 'luxon';
import type { ExcelSheetDef } from '~/common/exportUtils';
import type { Activity, MapFulfillmentRequest } from '~/common/types';
import { getAxiosClient } from './common';

const axios = getAxiosClient();

function dt(d: string) {
  return DateTime.fromISO(d);
}

function transformRequest(req: any): MapFulfillmentRequest {
  return {
    ...req,
    createdAt: dt(req.createdAt),
    updatedAt: dt(req.updatedAt),
    ...(req.startDate && { startDate: dt(req.startDate) }),
    ...(req.endDate && { endDate: dt(req.endDate) }),
    ...(req.completedAt && { completedAt: dt(req.completedAt) }),
    statusTransitions: req.statusTransitions?.map((t: any) => ({
      ...t,
      createdAt: dt(t.createdAt),
      updatedAt: dt(t.updatedAt),
    })),
  };
}

function transformActivity(activity: any): Activity {
  return {
    ...activity,
    createdAt: dt(activity.createdAt),
    updatedAt: dt(activity.updatedAt),
  };
}

export async function listDrfRequests(organizationId: string): Promise<MapFulfillmentRequest[]> {
  const { data } = await axios.get(`/v1/drf?organizationId=${organizationId}`);

  return data.map(transformRequest);
}

export async function getDrfRequestActivities(requestId: string, organizationId: string): Promise<Activity[]> {
  const { data } = await axios.get(`/v1/drf/drfRequestActivities/${requestId}?organizationId=${organizationId}`);

  return data.map(transformActivity);
}

export async function updateDrfRequest(
  requestId: string,
  properties: Partial<MapFulfillmentRequest>,
): Promise<MapFulfillmentRequest> {
  const { data } = await axios({
    method: 'PUT',
    url: `/v1/drf/${requestId}`,
    data: { properties },
  });

  return transformRequest(data);
}

export async function regenerateApprovalPacket(requestId: string): Promise<void> {
  const { data } = await axios({
    method: 'POST',
    url: `/v1/drf/${requestId}/regenerateApprovalPacket`,
  });

  return data;
}

export async function exportDrfTableToExcel(sheetDefs: ExcelSheetDef[]): Promise<Buffer> {
  const { data } = await axios({
    method: 'POST',
    url: `/v1/drf/exportDrfTableToExcel`,
    data: { sheetDefs },
    responseType: 'arraybuffer',
  });

  return data;
}
